import type { DerivedInvestorStatus, Investment } from '@/api/investing/types';
import { MyInvestmentBoardFundDto } from '@/api/investing-board/types';
import { type TableRow, TimeCell } from '@/design-system';
import { MobileCardField, MobileFieldsGrid } from '@/shared/design-system';

import { MobileCardList } from '../my-assets/mobile-card-list';
import { PendingAssetActions } from './pending-asset-actions';
import { StatusBadge } from './status-badge';

export interface PendingAssetRow extends TableRow {
  fundName: string;
  amountLabel: string;
  status: DerivedInvestorStatus | null;
  lastActivityAt: string;
  investment: Investment;
  fund?: MyInvestmentBoardFundDto;
}

export const PendingAssetsMobile = ({ rows }: { rows: PendingAssetRow[] }) => (
  <MobileCardList
    items={rows.map((row) => ({
      value: String(row.key),
      title: row.fundName,
      badge: <StatusBadge status={row.status} />,
      content: (
        <>
          <MobileFieldsGrid>
            <MobileCardField label="Amount" value={row.amountLabel} />
            <MobileCardField label="Last Activity">
              <TimeCell date={row.lastActivityAt} />
            </MobileCardField>
          </MobileFieldsGrid>
          <PendingAssetActions investment={row.investment} fund={row.fund} mobile />
        </>
      ),
    }))}
    defaultValue={rows[0] ? String(rows[0].key) : null}
    emptyMessage="No investments in progress."
  />
);
